import { useAppServices } from '~/app/contexts/app-context';
import { AemMarketConfig } from '~/app/market-config';

export type MarketFormatter = {
	/**
	 * Formats a consumption value according to the market's preferences.
	 */
	formatConsumption: (value: number | null | undefined) => string;
	/**
	 * Formats a price according to the numberformatter.
	 * @example
	 * DE: 1234.56 => '1.234,56 €'
	 * NO: 1234.56 => '1 234,56 NOK'
	 * CA: 1234.56 => '$ 1,234.56'
	 */
	formatPrice: (price: number | null | undefined) => string | null;
	/**
	 * Returns currency symbol according to markets preference.
	 */
	currency: () => string;
};

export type MarketFormatterFactory = (aemConfig: AemMarketConfig) => MarketFormatter;

const getLanguageIdentifier = (aemConfig: AemMarketConfig) => `${aemConfig.language}-${aemConfig.market}`;

export const FORMATTER_DEFAULT: MarketFormatterFactory = (aemConfig) => {
	const { featureServices } = useAppServices();
	const caeFormatter = new Intl.NumberFormat(getLanguageIdentifier(aemConfig), {
		minimumFractionDigits: 0,
		maximumFractionDigits: 1,
	});

	// Strip the formatted number for the currency code/symbol
	const currency = featureServices?.numberFormatterService?.formatCurrency(0).replace(/\d[\d\W]*\d/g, '');

	return {
		formatConsumption: (value) => {
			if (typeof value !== 'number') return '';
			return caeFormatter.format(value);
		},
		formatPrice: (price) => {
			if (typeof price !== 'number') return null;
			return featureServices?.numberFormatterService?.formatCurrency(price);
		},
		currency: () => {
			return currency;
		},
	};
};
